import React from "react";
import { FaWhatsapp } from "react-icons/fa";

const WHATSAPP_NUMBER = "31683855191";
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}`;

const WhatsAppFloatingButton = () => (
  <div className="fixed bottom-4 right-4 sm:bottom-6 sm:right-6 z-40" data-testid="whatsapp-floating-button">
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      className="flex items-center justify-center w-[50px] h-[50px] rounded-full bg-[#25D366] text-white shadow-lg hover:brightness-95 transition"
    >
      <FaWhatsapp size={35} />
    </a>
  </div>
);

export default WhatsAppFloatingButton;
